import {Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {AbstractControl, FormControl, Validators} from "@angular/forms";
import {TooltipService} from "@irb-common/components/tooltip/tooltip.service";

@Component({ standalone: false,
    selector: 'irb-external-share-holding',
    templateUrl: './external-share-holding.component.html',
    styleUrls: ['./external-share-holding.component.scss']
})
export class ExternalShareHoldingComponent {
    externalSharePrice: any;
    externalShareHoldingPriceInputField: ElementRef;
    private _externalShareHoldingData: any;
    private _isDataLoaded: boolean = false;
    externalSharePriceInputControl: FormControl = new FormControl();
    private places = 2;
    private minValue = 0.01;
    tooltipMessage = "";
    @Output()
    externalShareHoldingPriceChanged: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    set externalShareHoldingData(value: { multipleSecurity: boolean, isModelSecurity: boolean, securityData: any[] }) {
        this._externalShareHoldingData = value;
        this.loadData();
        this.initializeFormStructure();
    }

    constructor(private tts: TooltipService) {
    }

    private loadData() {
        if (this._externalShareHoldingData && !this._externalShareHoldingData.multipleSecurity
            && this._externalShareHoldingData.securityData) {
            let securityDtls = this._externalShareHoldingData.securityData[0];

            this.externalSharePrice = (isNaN(securityDtls.externalSharePrice)
                || securityDtls.externalSharePrice === undefined
                || securityDtls.externalSharePrice == null)
                ? 0 : securityDtls.externalSharePrice;
            this._isDataLoaded = true;
        }
    }

    initializeFormStructure() {
        this.externalSharePriceInputControl = new FormControl(this.externalSharePrice,
            [Validators.required,
               Validators.min(this.minValue),
                this.notANumberValidatorFn.bind(this),
                Validators.pattern(new RegExp("^(([0-9]*)|(([0-9]*)\.([0-9]{0,"+this.places+"})))$"))]);
        this.onFocusOut();
    }

    notANumberValidatorFn(control: AbstractControl): { [key: string]: any } | null {
        const re = /"^\d+(?:\.\d+)?$"/;

        return (control.value != null && control.value.length > 0
            && (isNaN(control.value) ? {'NotANumber': {value: control.value}} : null));
    }
    greaterThanZeroValidatorFn(control: AbstractControl): { [key: string]: any } | null {
        const re = /"^\d+(?:\.\d+)?$"/;

        return (control.value != null && control.value.length > 0
            && (!isNaN(control.value) && (parseFloat(control.value) <= 0) ? {'greaterThanZero': {value: control.value}} : null));
    }

    setFocus() {
        if (this.externalShareHoldingPriceInputField) {
            this.externalShareHoldingPriceInputField.nativeElement.focus();
        }

    }

    onInput() {
        // console.log(event);
        // console.log('ExternalSharePriceErrors', this.externalSharePriceInputControl.errors);
        // console.log('ExternalSharePriceControlValue', this.externalSharePriceInputControl.value);
        // console.log('event target Value', event.target.value);
        if (this.externalSharePriceInputControl && !this.externalSharePriceInputControl.valid
            && this.externalSharePriceInputControl.errors) {
            if (this.externalSharePriceInputControl.hasError('required')) {
                this.tooltipMessage = "Share price is required";
            } else if (this.externalSharePriceInputControl.hasError('NotANumber')) {
                this.tooltipMessage = "iRebal will assume a price of $1";
            } else if (this.externalSharePriceInputControl.hasError('min')) {
                this.tooltipMessage = "Please enter share price greater than or equal to 0.01";
            } else if (this.externalSharePriceInputControl.hasError('pattern')) {
                this.tooltipMessage = "Please limit share price out two decimals";
            }

        } else {

            this.tooltipMessage = "";
            this.tts.remove();

        }
    }

    onFocusOut() {
        if (this.externalSharePriceInputControl && !this.externalSharePriceInputControl.valid
            && this.externalSharePriceInputControl.errors) {
            if (this.externalSharePriceInputControl.hasError('required')) {
                this.tooltipMessage = "Share price is required";
            } else if (this.externalSharePriceInputControl.hasError('NotANumber')) {
                this.tooltipMessage = "iRebal will assume a price of $1";
            } else if (this.externalSharePriceInputControl.hasError('min')) {
                this.tooltipMessage = "Please enter share price greater than or equal to 0.01";
            } else if (this.externalSharePriceInputControl.hasError('pattern')) {
                this.tooltipMessage = "Please limit share price out two decimals";
            }
        }
    }

    onChange() {
        // console.log('Focus out Event', event);
        // console.log('External Share Price Control value', this.externalSharePriceInputControl.value);
        if (this.externalSharePriceInputControl && this.externalSharePriceInputControl.valid) {
            this.externalShareHoldingPriceChanged.emit(Number(this.externalSharePriceInputControl.value).toFixed(2));
        } else if (this.externalSharePriceInputControl && !this.externalSharePriceInputControl.valid
            && this.externalSharePriceInputControl.errors) {
            if (this.externalSharePriceInputControl.hasError('NotANumber')) {
                this.tooltipMessage = "";
                this.tts.remove();
                this.externalSharePriceInputControl.setValue('1.00');
                this.externalShareHoldingPriceChanged.emit(Number(this.externalSharePriceInputControl.value).toFixed(2));

            }
        } else {
            // do nothing
        }
    }

    public isValid() {
        let isValid = true;
        if(this.externalSharePriceInputControl) {
            isValid = isValid && this.externalSharePriceInputControl.valid;
        }
        return isValid;
    }
}
